export default __webpack_public_path__ + "static/media/product-lock-lp.95331b09.png";